import A11yDialog from 'a11y-dialog'

const createDialogs = () => {
  const dialogs = document.querySelectorAll('[data-dialog]')
  window.dialogs = []

  dialogs.forEach(dialogEl => {
    const dialog = new A11yDialog(dialogEl)
    dialog.on('show', () => {
      document.body.classList.add('no-scroll')
      dialogEl.removeAttribute('style')
    })

    dialog.on('hide', () => {
      document.body.classList.remove('no-scroll')
    })

    window.dialogs.push(dialog)
  })
}

export default createDialogs
